import { Anchor, Stack, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useTranslation } from '@refinedev/core';
import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import type { Claim } from 'interfaces';

export const useClaimStatusChangeNotification = () => {
  const { translate } = useTranslation();

  return useCallback(
    (previousClaim: Claim | undefined, savedClaim?: Claim) => {
      if (
        !savedClaim?.id ||
        (previousClaim && savedClaim.id !== previousClaim.id)
      ) {
        return;
      }

      const notificationID = `claim-status-changed-${savedClaim.id}`;
      notifications.show({
        id: notificationID,
        title: translate('pages:claims.statusChange.title', 'Claim saved'),
        message: (
          <Stack gap="xs">
            <Text size="sm" c="inherit">
              {savedClaim.claimNumber
                ? translate(
                    'pages:claims.statusChange.numberedDescription',
                    { claimNumber: savedClaim.claimNumber },
                    `Claim ${savedClaim.claimNumber} was saved.`
                  )
                : translate(
                    'pages:claims.statusChange.description',
                    'The claim was saved.'
                  )}
            </Text>
            <Anchor
              component={Link}
              to={`/claims/edit/${savedClaim.id}`}
              onClick={() => notifications.hide(notificationID)}
            >
              {translate('pages:claims.statusChange.openClaim', 'Open claim')}
            </Anchor>
          </Stack>
        ),
        color: 'teal',
        position: 'top-right',
        autoClose: false,
        withCloseButton: true,
        withBorder: true,
      });
    },
    [translate]
  );
};
